export const MFA_SINGLE_SESSION_TABS_LABELS = {
	OVERVIEW: 'Overview',
	ALL_ISSUES: 'All Issues',
	SCANS: 'Scans'
} as const;
